import { createLogger } from '@eventstore-ui/utils';
import { INTERNAL_ROUTER } from './globals.mjs';

const logger = createLogger('searchParam', '#333');
class SearchParam {
    constructor(key) {
        this.set = (value) => {
            if (value == null)
                return this.delete();
            if (!window[INTERNAL_ROUTER]) {
                logger.error(`Attemped to set "${this.key}" to "${value}" in search params before router was initialized`, this.key, value);
                return;
            }
            const search = this.params;
            search.set(this.key, value);
            this.updateParams(search);
        };
        this.delete = () => {
            if (!window[INTERNAL_ROUTER]) {
                logger.error(`Attemped to remove "${this.key}" in search params before router was initialized`, this.key);
                return;
            }
            const search = this.params;
            search.delete(this.key);
            this.updateParams(search);
        };
        this.updateParams = (search) => {
            window[INTERNAL_ROUTER].history.replace(Object.assign(Object.assign({}, window[INTERNAL_ROUTER].history.location), { search: search.toString() }), undefined, false);
        };
        this.key = key;
    }
    get value() {
        var _a;
        if (!window[INTERNAL_ROUTER]) {
            logger.error(`Attemped to get "${this.key}"in search params before router was initialized`, this.key);
            return;
        }
        return (_a = this.params.get(this.key)) !== null && _a !== void 0 ? _a : undefined;
    }
    get params() {
        var _a;
        return new URLSearchParams((_a = window[INTERNAL_ROUTER]) === null || _a === void 0 ? void 0 : _a.history.location.search);
    }
}
/**
 * Create a search param tracker, to set and update a search param in the current location.
 * @usage ./searchParam.usage.md
 */
const searchParam = (key) => new SearchParam(key);

export { logger, searchParam };
